const isImage = (source: string) => {
    const extensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg"];
    return extensions.some((extension) => source?.toLowerCase().endsWith(extension));
};

export default isImage;
